import axios from 'axios';

const initialState = {
  contactGroups: [],
  isShownContactSyncDrawer: false,
  hasSyncStarted: false,
  syncStatus: '',
  error: '',
};

export default {
  namespaced: true,
  state: { ...initialState },
  mutations: {
    setContactGroups(state, groups) {
      state.contactGroups = groups;
    },
    setShowContactSyncDrawer(state, boolean) {
      state.isShownContactSyncDrawer = boolean;
    },
    setHasSyncStarted(state, boolean) {
      state.hasSyncStarted = boolean;
    },
    setSyncStatus(state, status) {
      state.syncStatus = status;
    },
    setError(state, error) {
      state.error = error;
    },
  },
  getters: {
    hasSyncFinished(state) {
      return state.syncStatus === '' || state.syncStatus === 'finished';
    },
  },
  actions: {
    async getContactGroups({ commit }, email) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_NYLAS_API_BASE_URL}/email-accounts/groups?app=crm&email=${email}`);
        commit('setContactGroups', response.data.groups);
      } catch (error) {
        commit('setError', error.message);
      }
    },
    async syncGroup({ commit }, payload) {
      try {
        const { groupId, email } = payload;
        await axios.post(`${process.env.VUE_APP_NYLAS_API_BASE_URL}/email-accounts/groups/${groupId}/sync?app=crm`,
          {
            email,
          });
        commit('setHasSyncStarted', true);
      } catch (error) {
        commit('setError', error.message);
      }
    },
    async getSyncStatus({ commit }, emailAccountId) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_NYLAS_API_BASE_URL}/contact-sync/${emailAccountId}/status?app=crm`);
        commit('setSyncStatus', response.data.status);
      } catch (error) {
        commit('setError', error.message);
      }
    },
  },
};
